const FALLBACK_RARITIES = [
  { code: "common", display_name: "Comun", symbol_shape: "circle", symbol_count: 1, symbol_color: "black" },
  { code: "uncommon", display_name: "Infrecuente", symbol_shape: "diamond", symbol_count: 1, symbol_color: "black" },
  { code: "rare", display_name: "Rara", symbol_shape: "star", symbol_count: 1, symbol_color: "black" },
  { code: "rare_holo", display_name: "Rara Holo", symbol_shape: "star", symbol_count: 1, symbol_color: "black" },
  { code: "double_rare", display_name: "Rara Doble", symbol_shape: "star", symbol_count: 2, symbol_color: "black" },
  { code: "ultra_rare", display_name: "Rara Ultra", symbol_shape: "star", symbol_count: 2, symbol_color: "silver" },
  { code: "illustration_rare", display_name: "Rara Ilustracion", symbol_shape: "star", symbol_count: 1, symbol_color: "gold" },
  { code: "special_illustration_rare", display_name: "Rara Ilustracion Especial", symbol_shape: "star", symbol_count: 2, symbol_color: "gold" },
  { code: "hyper_rare", display_name: "Rara Hiper", symbol_shape: "star", symbol_count: 3, symbol_color: "gold" }
];

const SPECIAL_RARITY_CODES = new Set([
  "ace_spec", "promo", "amazing_rare", "radiant_rare", "pikachu_rare",
  "mega_attack_rare", "mega_hyper_rare", "black_white_rare",
  "futuristic_rare", "classic_collection"
]);

const normalize = value => String(value || "")
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .trim()
  .toLowerCase();

export const resolveRarityDisplay = (value, options = []) => {
  const label = String(value || "").trim();
  if (!label) return { label: "Sin rareza", glyph: "", color: "neutral", isSpecial: false };

  const candidates = [...options, ...FALLBACK_RARITIES];
  const rarity = candidates.find(item => {
    const values = [item.display_name, item.code, ...(item.aliases || [])].map(normalize);
    return values.includes(normalize(label));
  });

  if (!rarity) return { label, glyph: "", color: "neutral", isSpecial: true };
  if (SPECIAL_RARITY_CODES.has(rarity.code)) {
    return { label: rarity.display_name || label, glyph: "", color: "special", isSpecial: true };
  }

  const shape = rarity.symbol_shape === "circle"
    ? "\u25CF"
    : rarity.symbol_shape === "diamond"
      ? "\u25C6"
      : "\u2605";
  return {
    label: rarity.display_name || label,
    glyph: shape.repeat(Math.max(1, Number(rarity.symbol_count) || 1)),
    color: rarity.symbol_color || "black",
    isSpecial: false
  };
};

export function RarityMark({ rarity, options = [], compact = false }) {
  const display = resolveRarityDisplay(rarity, options);
  if (!rarity) return compact ? null : <span className="rarity-mark is-neutral">Sin rareza</span>;
  return (
    <span
      className={`rarity-mark is-${display.color} ${display.isSpecial ? "is-special" : ""} ${compact ? "is-compact" : ""}`}
      title={display.label}
      aria-label={display.label}
    >
      {display.glyph && <b aria-hidden="true">{display.glyph}</b>}
      {!compact && <span>{display.label}</span>}
      {compact && display.isSpecial && <b aria-hidden="true">ESP</b>}
    </span>
  );
}
